import { Boss } from './Boss';
import Phaser from 'phaser';

export class ShieldBoss extends Boss {
  private shieldActive: boolean = false;
  private shieldDuration: number = 3000; // 3s
  private shieldCooldown: number = 8000; // 8s
  private lastShieldTime: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 400;
    this.maxHealth = 400;
    this.speed = 22;
    this.reward = 200;
    this.specialAbility = 'Shield Immunity';
    // Visual: boss xanh lam
    const circle = scene.add.circle(0, 0, 22, 0x2196f3);
    circle.setName('bossCircle');
    this.add(circle);
  }

  override activateAbility(): void {
    const now = this.scene.time.now;
    if (!this.shieldActive && now - this.lastShieldTime > this.shieldCooldown) {
      this.shieldActive = true;
      this.lastShieldTime = now;
      this.showShieldEffect();
      this.scene.time.delayedCall(this.shieldDuration, () => {
        this.shieldActive = false;
        this.hideShieldEffect();
      });
    }
  }

  override takeDamage(amount: number): void {
    if (this.shieldActive) {
      // Miễn nhiễm sát thương
      this.showShieldHitEffect();
      return;
    }
    super.takeDamage(amount);
  }

  private showShieldEffect(): void {
    const circle = this.getByName('bossCircle');
    if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(0x00e5ff);
      circle.fillCircle(0, 0, 22);
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(0x00e5ff);
    }
  }

  private hideShieldEffect(): void {
    const circle = this.getByName('bossCircle');
    if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(0x2196f3);
      circle.fillCircle(0, 0, 22);
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(0x2196f3);
    }
  }

  private showShieldHitEffect(): void {
    const circle = this.getByName('bossCircle');
    const _this = this;
    if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(0xffffff);
      circle.fillCircle(0, 0, 22);
      this.scene.time.delayedCall(100, () => {
        _this.showShieldEffect();
      });
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(0xffffff);
      this.scene.time.delayedCall(100, () => {
        _this.showShieldEffect();
      });
    }
  }
} 